import {  createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var DeleteBrandRes;
export const DeleteBrandTodo = createAsyncThunk('DeleteBrand', async (id) => {
    // console.log("data", data)
    try {
        const res = await axios({
            method: "Delete",
            url: process.env.REACT_APP_API_URL + `vehicle_brand/${id}`,
            headers: { "Content-Type": "application/json" , "Authorization": 'Bearer ' + localStorage.getItem('user_token') }
        })
        return DeleteBrandRes = res.data
        
    } catch (error) {
        return DeleteBrandRes = error.response.data
    }
})
